import script from "./SVGIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./SVGIcon.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__